module.exports = __webpack_public_path__ + "static/media/Watercraft.595affe6.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/png-images/Watercraft.png
// module id = 3034
// module chunks = 0